import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../appState.interface";

export const calendarState = (state: AppStateInterface) => state.calendarState;

export const calendarLaunchingSelector = createSelector(
  calendarState,
  (state) => state.launching
);
